// Права текущего пользователя, которые нужны не только меню, но и отдельным экранам.
//
// Layout загружает /me/limits и кладёт ответ сюда. Сейчас отсюда читается одно:
// видит ли пользователь деньги модуля «Хостел». Сотрудник компании, чьей роли
// администратор не дал вкладку «Финансы», не видит их нигде — ни оплат жильцов,
// ни ставок компаний и хостелов, ни касс. Настоящий запрет — на сервере (он не
// отдаёт эти поля и отвечает 403 на запросы с деньгами), здесь только прячем
// кнопки и поля, чтобы не показывать пустые блоки.
import { useEffect, useState } from "react";

const STORAGE_KEY = "tabel_limits";
const listeners = new Set();

function readSaved() {
    try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
    } catch {
        return null;
    }
}

let limits = readSaved();

export function setAccessLimits(next) {
    limits = next || null;
    try {
        if (limits) localStorage.setItem(STORAGE_KEY, JSON.stringify(limits));
        else localStorage.removeItem(STORAGE_KEY);
    } catch {
        /* хранилище недоступно — просто не запоминаем между загрузками */
    }
    listeners.forEach((fn) => fn());
}

export function canSeeHostelFinance() {
    if (limits && typeof limits.hostel_finance === "boolean") return limits.hostel_finance;
    const tabs = limits?.allowed_tabs;
    return !tabs || (tabs.hostel || []).includes("/hostel/finance");
}

/** Реактивный вариант canSeeHostelFinance(): перерисует экран, когда права загрузятся. */
export function useHostelFinance() {
    const [allowed, setAllowed] = useState(canSeeHostelFinance());
    useEffect(() => {
        const update = () => setAllowed(canSeeHostelFinance());
        listeners.add(update);
        update();
        return () => listeners.delete(update);
    }, []);
    return allowed;
}
